import(/* webpackMode: "eager", webpackExports: ["BlogContent"] */ "/vercel/path0/components/blog/BlogContent.tsx");
